import styled from "styled-components";
import { Typography } from "@material-ui/core";

export const STTableHeadTypography = styled(Typography)`
  && {
    color: black;
    font-weight: 600;
    font-size: 0.8rem;
  }
`;
